"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScoreThermometer = exports.getHeight = exports.getColor = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const base_react_components_1 = require("@navinc/base-react-components");
const ThermometerWrapper = styled_components_1.default.figure.withConfig({ displayName: "reports-ThermometerWrapper", componentId: "reports-1ow7eek" }) `
  align-items: stretch;
  justify-content: stretch;
  margin: 0;
  display: grid;
  grid-template-columns: 0.35em 1fr;
  gap: 8px;
`;
const getColor = (score = 0, maxPoor = 0, maxFair = 0) => {
    if (score > maxFair)
        return base_react_components_1.theme.good;
    if (score > maxPoor)
        return base_react_components_1.theme.fair;
    return base_react_components_1.theme.poor;
};
exports.getColor = getColor;
const getHeight = (score = 0, maxGood = 0, minScore = 0) => ((score - minScore) / (Math.max(score, maxGood) - minScore)) * 100;
exports.getHeight = getHeight;
const ThermometerBase = styled_components_1.default.div.withConfig({ displayName: "reports-ThermometerBase", componentId: "reports-1oqeczi" }) `
  border-radius: 1em;
  background-color: hsl(0, 0%, 0%, 0.1);
  transform: rotateX(180deg);
`;
const fadeId = (height) => (0, styled_components_1.keyframes) `
  from {
    height: 0%;
  }
  to {
    height: ${height}%;
  }
`;
const animation = ({ score }) => (0, styled_components_1.css) `
  animation: ${fadeId(score)} 1s forwards;
`;
const ThermometerFill = styled_components_1.default.div.withConfig({ displayName: "reports-ThermometerFill", componentId: "reports-rwz1jf" }) `
  background-color: ${({ color = '' }) => color};
  border-radius: 1em;
  ${animation};
`;
const Thermometer = (_a) => {
    var { score, maxGood, maxPoor, maxFair, minScore } = _a, props = __rest(_a, ["score", "maxGood", "maxPoor", "maxFair", "minScore"]);
    const numberScore = +(score !== null && score !== void 0 ? score : 0);
    const scoreHeight = (0, exports.getHeight)(numberScore, maxGood, minScore);
    const scoreColor = (0, exports.getColor)(numberScore, maxPoor, maxFair);
    return (react_1.default.createElement(ThermometerBase, Object.assign({}, props, { "data-testid": "thermometer" }),
        react_1.default.createElement(ThermometerFill, { score: scoreHeight, color: scoreColor })));
};
/** The Score Thermometer reflects the given score in height and color relative to the possible ranges provided */
const ScoreThermometer = (_a) => {
    var _b;
    var { score, maxGood, maxPoor, maxFair, minScore } = _a, props = __rest(_a, ["score", "maxGood", "maxPoor", "maxFair", "minScore"]);
    return (react_1.default.createElement(ThermometerWrapper, null,
        score && (react_1.default.createElement(Thermometer, Object.assign({ score: score, maxGood: maxGood, maxPoor: maxPoor, maxFair: maxFair, minScore: minScore }, props))),
        react_1.default.createElement(base_react_components_1.Header, { bold: true, size: "xl" }, (_b = (score === 'No Score' ? undefined : score)) !== null && _b !== void 0 ? _b : '...')));
};
exports.ScoreThermometer = ScoreThermometer;
exports.default = exports.ScoreThermometer;
//# sourceMappingURL=index.js.map